import { useQuery } from '@tanstack/react-query';

import { listTags } from 'api/tags';
import { queryKeys } from 'constants/queryKeys';
import { tagManagementStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import type { TTag } from 'types';
import { toErrorMessage } from './utils';

type UseTagsResult = {
  tags: TTag[];
  loading: boolean;
  error: string | undefined;
  refetch: () => Promise<unknown>;
};

type UseTagsOptions = {
  enabled?: boolean;
};

export function useTags({ enabled = true }: UseTagsOptions = {}): UseTagsResult {
  const { user } = useAuth();
  const canFetch = Boolean(user?.uid) && enabled;

  const query = useQuery({
    queryKey: [queryKeys.TAGS, user?.uid],
    enabled: canFetch,
    queryFn: listTags,
    retry: false,
  });

  // 取得を止めている間はキャッシュに残った前回のタグ・エラーを返さない（機能OFF後に古いタグ名を出さない）
  if (!canFetch) {
    return { tags: [], loading: false, error: undefined, refetch: query.refetch };
  }

  return {
    tags: query.data ?? [],
    loading: query.isPending || query.isFetching,
    error: query.error
      ? toErrorMessage(query.error, tagManagementStrings.errors.loadTagsFailed)
      : undefined,
    refetch: query.refetch,
  };
}
